module.exports = __webpack_public_path__ + "img/smithsonian.757832ae.png";